import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WorkshopJobListStore } from '../workshop-job-list.store.service';
import { REPAIR_DOCKET } from 'src/testIds';
import { WorkshopJobStatusLabelPipe } from '../../../shared/pipes/workshop-job-status-label.pipe';
import { WorkshopJobNamePipe } from '../../../shared/pipes/workshop-job-name.pipe';
import { UserIdToNamePipe } from '../../../shared/pipes/user-id-to-name.pipe';
import { LocationNameFromIdPipe } from '../../../shared/pipes/location-name-from-id.pipe';
import { RouterLink } from '@angular/router';
import {
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow
} from '@angular/material/table';
import { TestIdDirective } from '../../../shared/directives/test-id.directive';
import { NgIf, AsyncPipe, CurrencyPipe, DatePipe } from '@angular/common';

@Component({
  selector: 'app-workshop-jobs-table',
  templateUrl: './workshop-jobs-table.component.html',
  standalone: true,
  imports: [
    NgIf,
    TestIdDirective,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    RouterLink,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    AsyncPipe,
    CurrencyPipe,
    DatePipe,
    LocationNameFromIdPipe,
    UserIdToNamePipe,
    WorkshopJobNamePipe,
    WorkshopJobStatusLabelPipe
  ]
})
export class WorkshopJobsTableComponent {
  testIds = REPAIR_DOCKET;
  @Input() currency = 'GBP';
  @Output() print = new EventEmitter<number>();

  constructor(private workshopJobListStore: WorkshopJobListStore) {}

  itemsWithParts$ = this.workshopJobListStore.itemsWithParts$;

  displayedColumns = [
    'job_number',
    'repairable',
    'status',
    'booked_in',
    'total_cost',
    'actions'
  ];

  doPrint(jobId: number) {
    console.log('clicked print on', jobId);
    this.print.emit(jobId);
  }
}
